import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

function invoiceKeys(queryClient: ReturnType<typeof useQueryClient>) {
  return Promise.all([
    queryClient.invalidateQueries({
      queryKey: orpc.accountsPayable.invoices.list.key(),
    }),
    queryClient.invalidateQueries({
      queryKey: orpc.accountsPayable.invoices.get.key(),
    }),
    queryClient.invalidateQueries({
      queryKey: orpc.accountsPayable.invoices.listChangeLog.key(),
    }),
  ]);
}

export function useSnoozeAPInvoices() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.accountsPayable.invoices.snooze.mutationOptions({
      onSuccess: () => {
        void invoiceKeys(queryClient);
      },
    }),
  );
}

export function useClearAPInvoiceSnoozes() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.accountsPayable.invoices.clearSnooze.mutationOptions({
      onSuccess: () => {
        void invoiceKeys(queryClient);
      },
    }),
  );
}
